import { Platform } from "react-native";
import Constants from "expo-constants";
import WebClarityFunctions from "./WebClarity";
import FBClarityFunctions from "./FallbackClarity";

export interface BEClarityProps {
  initializeClarity: (project_id: string) => void,
  setCustomTag: (tag: string, value: string) => void,
  identify: (player_id: string, session_id?: string) => void,
  smartEvent: (event: string) => void
}

let BEClarity: BEClarityProps;

if (Platform.OS === 'web') {
  BEClarity = WebClarityFunctions;
} else if (Constants.executionEnvironment === 'storeClient') {
  // In Expo Go — use fallback
  BEClarity = FBClarityFunctions;
} else {
  // Only load native module in custom dev client or standalone
  const RNClarityFunctions = require("./RNClarity").default;
  BEClarity = RNClarityFunctions;
}

export default BEClarity;